import captionService from 'CaptionService';

export const notes = {
	close: () => captionService.getString('3f7b8f8c-8ef3-4997-99b0-b2d9bb11d92d', 'Close'),
	noteData: () => captionService.getString('06985e37a-24ee-4d89-95e7-5d8e614298df', 'Note Data'),
	noteText: () => captionService.getString('2abecbd5-c6c8-49d0-bd51-5aff81d4c368', 'Note Text'),
	title: () => captionService.getString('09532c70-bf54-4a2a-b8c9-c801910afacb', 'Notes'),
};
